export const DisableLoading = function() {
    // hide modal loading window
    $("#ModalLoading:hidden").remove();
    $("#ModalLoading").modal("hide");

    // make sure we dont have multiple modal backdrops
    if ($(".modal-backdrop").length > 1) $(".modal-backdrop:not(:last)").remove();

    $.event.trigger({ type: 'disableModal', message: 'modal was disabled', date: new Date() });
}